import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import TextField from '@mui/material/TextField'
import ClearIcon from '@mui/icons-material/Clear'
import IconButton from '@mui/material/IconButton'
import { makeStyles } from '@mui/styles'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import AdapterJalaali from '@date-io/jalaali'
import moment from 'moment-jalaali'

import { isInternationalVersion } from '../../../settings/locale.settings'
import { toPersianDigit } from '../../../helpers/generalHelpers'
import FieldWrapper from '../FieldRowWrapper'
import { shouldFlip } from '../../../stories/helpers/theme'

const useStyles = makeStyles((theme) => ({
  iconButton: {
    flip: shouldFlip(theme),
    left: -theme.spacing(1),
    padding: '12px 6px',
    '& svg': {
      fontSize: 15,
    },
  },
}))
export const DateAndTimePicker = ({
  label = '',
  name = '',
  placeholder,
  required,
  touched,
  error,
  description,
  from_date,
  to_date,
  value,
  onChange,
  onInputFocus,
  onInputBlur,
  ...props
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()
  const [locale, setLocale] = useState(isInternationalVersion() ? 'en' : 'fa')

  const dateTimeFormat = 'YYYY-MM-DD HH:mm'

  useEffect(() => {
    setLocale(isInternationalVersion() ? 'en' : 'fa')
  }, [])

  const timezoneOffset = new Date().getTimezoneOffset()

  const changeDate = (date) => {
    let utcDate = null
    if (date) {
      if (locale === 'fa') {
        const theDate = moment(
          date.format('jYYYY/jMM/jDD HH:mm'),
          'jYYYY/jMM/jDD HH:mm'
        ).format(dateTimeFormat)

        utcDate = moment(theDate).utc().utcOffset(timezoneOffset).format()
      } else {
        utcDate = date.utc().format()
      }
    }

    onChange(utcDate)
  }

  const getInputValue = () => {
    if (value) return moment(value).format(dateTimeFormat)
    return null
  }

  const labelFunc = (date) => {
    if (date) {
      return isInternationalVersion()
        ? date.format(dateTimeFormat)
        : toPersianDigit(date.format('jYYYY/jMM/jDD HH:mm'))
    }
    return ''
  }

  return (
    <FieldWrapper
      error={error}
      touched={touched ? touched.toString() : undefined}
    >
      <LocalizationProvider
        dateAdapter={isInternationalVersion() ? AdapterMoment : AdapterJalaali}
      >
        <DateTimePicker
          name={name}
          value={getInputValue()}
          clearLabel="clear"
          onChange={changeDate}
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          labelFunc={labelFunc}
          label={label}
          error={Boolean(error)}
          InputProps={{
            startAdornment: (
              <IconButton
                onClick={() => onChange(null)}
                className={classes.iconButton}
                size="large"
              >
                <ClearIcon />
              </IconButton>
            ),
          }}
          renderInput={({ inputProps, ...restParams }) => (
            <TextField
              {...restParams}
              inputProps={{
                ...inputProps,
                placeholder:
                  placeholder ||
                  formatMessage({ id: 'form.fields.date.time.placeholder' }),
              }}
            />
          )}
        />
      </LocalizationProvider>
    </FieldWrapper>
  )
}
